import { render, staticRenderFns } from "./Page07NewSub.vue?vue&type=template&id=788e02a1&scoped=true&"
import script from "./Page07NewSub.vue?vue&type=script&lang=js&"
export * from "./Page07NewSub.vue?vue&type=script&lang=js&"
import style0 from "./Page07NewSub.vue?vue&type=style&index=0&id=788e02a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788e02a1",
  null
  
)

export default component.exports
import {QCard,QCardSection,QTabPanels,QTabPanel,QCircularProgress,QTooltip,QList,QItem,QItemSection,QIcon,QSeparator,QTabs,QTab,QItemLabel,QScrollArea,QDialog,QBar,QSpace,QBtn,QMarkupTable,QTable,Ripple,ClosePopup} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QTabPanels,QTabPanel,QCircularProgress,QTooltip,QList,QItem,QItemSection,QIcon,QSeparator,QTabs,QTab,QItemLabel,QScrollArea,QDialog,QBar,QSpace,QBtn,QMarkupTable,QTable}, component.options.components || {})
component.options.directives = Object.assign({Ripple,ClosePopup}, component.options.directives || {})
